import {SidebarTrigger} from "@/components/ui/sidebar";
import {useStoredCompany} from "@/src/modules/company/store";
import {DirectMessagesSidebarLink} from "@/src/modules/direct-messages/components/direct-messages-sidebar-link";
import {NotificationFeedBellButton} from "@/src/modules/notification-feed/components";

import {useIsMobile, useIsPropertyBannerVisible} from "../hooks";
import {useStoredMe} from "../store/me";
import {useStoredUserProperty} from "../store/user-property";
import {APP_BRAND_NAME, LOGO_URL_MOBILE} from "../utils/constants";

import {NavUser} from "./nav-user";

export default function MobileHeader() {
  const isMobile = useIsMobile();
  const company = useStoredCompany();
  const me = useStoredMe();
  const isResidentShell = Boolean(me?.isResident);
  const property = useStoredUserProperty();
  const isPropertyBannerVisible = useIsPropertyBannerVisible();

  if (!isMobile) {
    return null;
  }

  return (
    <header className="z-20 w-full shrink-0 bg-background shadow-sm">
      <div className="flex h-[4rem] items-center justify-between gap-2 p-2">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          {!isResidentShell ? <SidebarTrigger className="size-10 shrink-0" /> : null}
          <img
            width="35"
            height="35"
            alt="logo"
            src={LOGO_URL_MOBILE}
            className="size-[35px] shrink-0"
          />
          <div className="min-w-0">
            <h1 className="truncate text-xl leading-none font-bold text-foreground">
              {APP_BRAND_NAME}
            </h1>
            {company?.name ? (
              <p className="truncate text-xs whitespace-nowrap text-muted-foreground">
                {company.name}
              </p>
            ) : null}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          {isResidentShell ? <NavUser me={me} variant="header" /> : null}
          <DirectMessagesSidebarLink />
          <NotificationFeedBellButton badgeVariant="dot" />
        </div>
      </div>
      {isPropertyBannerVisible && property?.name ? (
        <div className="flex h-8 items-center justify-center bg-primary/10 text-sm font-semibold text-primary">
          {property.name}
        </div>
      ) : null}
    </header>
  );
}
